<script setup>
import { computed } from "vue";
import { cn } from "@/shared/lib/utils";
import SvgIcon from "@/shared/ui/svg-icon/SvgIcon.vue";
import { tagVariants } from ".";

const props = defineProps({
  variant: {
    type: String,
    default: "primary",
    validator: (v) =>
      [
        "primary",
        "success",
        "danger",
        "warning",
        "default",
        "outline",
      ].includes(v),
  },
  size: {
    type: String,
    default: "md",
    validator: (v) => ["xs", "sm", "md", "lg"].includes(v),
  },
  closable: {
    type: Boolean,
    default: false,
  },
  closeIcon: {
    type: String,
    default: "huge-close",
  },
  class: {
    type: [String, Object, Array],
    default: undefined,
  },
});

const emit = defineEmits(["close"]);

const closeIconSize = computed(() => {
  if (props.size === "xs") return "w-2.5 h-2.5";
  if (props.size === "sm") return "w-3 h-3";
  if (props.size === "lg") return "w-4 h-4";
  return "w-3.5 h-3.5";
});

function handleClose(e) {
  e.stopPropagation();
  emit("close", e);
}
</script>

<template>
  <div :class="cn(tagVariants({ variant, size }), props.class)">
    <slot name="leading" />
    <slot />
    <button
      v-if="closable"
      type="button"
      class="tag-close inline-flex items-center justify-center cursor-pointer opacity-60 hover:opacity-100 transition-opacity"
      @click="handleClose"
    >
      <SvgIcon :name="closeIcon" :class="closeIconSize" />
    </button>
  </div>
</template>

<style scoped lang="scss">
.tag-close {
  background: transparent;
  border: none;
  padding: 0;
  color: inherit;
}
</style>
